import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    androidCode: '',
    androidUrl: '',
    companyNameCn: '',
    companyNameEn: '',
    icpNum: '',
    iosCode: '',
    iosUrl: '',
    mobileWebCode: '',
    qqGroupNum: '',
    qqService: '',
    webDescribe: '',
    webKeyword: '',
    wechatOfficialAccounts: '',
    wechatOfficialCode: '',
    wechatService: ''

  },
  mutations: {
    saveAndroidCode (state, androidCode) {
      state.androidCode = androidCode
    },
    saveAndroidUrl (state, androidUrl) {
      state.androidUrl = androidUrl
    },
    saveCompanyNameCn (state, companyNameCn) {
      state.companyNameCn = companyNameCn
    },
    saveCompanyNameEn (state, companyNameEn) {
      state.companyNameEn = companyNameEn
    },
    saveIcpNum (state, icpNum) {
      state.icpNum = icpNum
    },
    saveIosCode (state, iosCode) {
      state.iosCode = iosCode
    },
    saveIosUrl (state, iosUrl) {
      state.iosUrl = iosUrl
    },
    saveMobileWebCode (state, mobileWebCode) {
      state.mobileWebCode = mobileWebCode
    },
    saveQqGroupNum (state, qqGroupNum) {
      state.qqGroupNum = qqGroupNum
    },
    saveQqService (state, qqService) {
      state.qqService = qqService
    },
    saveWebDescribe (state, webDescribe) {
      state.webDescribe = webDescribe
    },
    saveWebKeyword (state, webKeyword) {
      state.webKeyword = webKeyword
    },
    saveWechatOfficialAccounts (state, wechatOfficialAccounts) {
      state.wechatOfficialAccounts = wechatOfficialAccounts
    },
    saveWechatOfficialCode (state, wechatOfficialCode) {
      state.wechatOfficialCode = wechatOfficialCode
    },
    saveWechatService (state, wechatService) {
      state.wechatService = wechatService
    }
  },
  actions: {
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js